import { produce } from 'immer';
import * as types from './assignedPointsTypes';
import createReducer from '../../utils/createReducer';

const initialState = {
    records: [],
    totalRecords: 0,
    loading: true,
};

const actionHandlers = {
    [types.GET_ASSIGNED_POINTS.REQUEST]: produce((draft) => {
        draft.loading = true;
    }),
    [types.GET_ASSIGNED_POINTS.SUCCESS]: produce(
        (draft, { total, records }) => {
            draft.records = records;
            draft.totalRecords = total;
            draft.loading = false;
        }
    ),
    [types.GET_ASSIGNED_POINTS.FAILURE]: produce((draft) => {
        draft.loading = false;
    }),
    [types.RESET_ASSIGNED_POINTS.SUCCESS]: produce((draft) => {
        draft.records = [];
        draft.totalRecords = 0;
        draft.loading = true;
    }),
};

export default createReducer(initialState, actionHandlers);
